// sorts.js
import { ASC, DESC } from "constants/sorts";

export const TOP_TRANSACTION_SORTS = {
  ALPHABETICAL: "ALPHABETICAL",
  RESPONSE_TIME: "RESPONSE_TIME",
  REQUESTS: "REQUESTS",
  ERROR_RATE: "ERROR_RATE",
};
export const TOP_HOSTS_SORTS = Object.assign({}, TOP_TRANSACTION_SORTS);

export const SPAN_MULTI_SELECT_SORTS = {
  LAYER: "layer",
  DURATION: "duration",
  DURATION_PERCENT: "durationPercent",
};

export const TRACE_SPANS_SORTS = {
  SPAN: "span",
  DURATION: "duration",
  DURATION_PERCENT: "durationPercent",
  COUNT: "count",
  ERRORS: "errors",
};

export const TRACE_QUERIES_SORTS = {
  QUERY: "query",
  COUNT: "count",
  AVERAGE: "average",
  TOTAL: "total",
};

export const TRACE_ERRORS_SORTS = {
  ERROR: "error",
  SPAN: "span",
  HOST: "host",
  TIME: "time",
};

const VALID_SORTS = {
  topTransactions: Object.values(TOP_TRANSACTION_SORTS),
  topHosts: Object.values(TOP_HOSTS_SORTS),
  spanMultiSelect: Object.values(SPAN_MULTI_SELECT_SORTS),
  traceSpans: Object.values(TRACE_SPANS_SORTS),
  traceQueries: Object.values(TRACE_QUERIES_SORTS),
  traceErrors: Object.values(TRACE_ERRORS_SORTS),
};

export const INITIAL_STATE = {
  topTransactions: {
    sort: TOP_TRANSACTION_SORTS.REQUESTS,
    direction: DESC,
  },
  topHosts: {
    sort: TOP_HOSTS_SORTS.requests_per_minute,
    direction: DESC,
  },
  spanMultiSelect: {
    sort: SPAN_MULTI_SELECT_SORTS.DURATION,
    direction: DESC,
  },
  traceSpans: {
    sort: TRACE_SPANS_SORTS.DURATION,
    direction: DESC,
  },
  traceQueries: {
    sort: TRACE_QUERIES_SORTS.TOTAL,
    direction: DESC,
  },
  traceErrors: {
    sort: TRACE_ERRORS_SORTS.TIME,
    direction: DESC,
  },
};

// action types
const HANDLE_SORT = "trace-web/sorts/HANDLE_SORT";

// reducer
const sortsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case HANDLE_SORT: {
      const validColumns = VALID_SORTS[action.listName];

      if (!validColumns) return state;
      if (!validColumns.includes(action.column)) return state;

      const current = state[action.listName];
      let next = {
        sort: action.column,
        direction: DESC,
      };
      if (action.column === current.sort) {
        next.direction = current.direction === ASC ? DESC : ASC;
      }
      let out = Object.assign({}, state);
      out[action.listName] = next;
      return out;
    }
    default:
      return state;
  }
};
export default sortsReducer;

// action creators
export const handleSort = (listName, column) => {
  return {
    type: HANDLE_SORT,
    listName,
    column,
  };
};
